import React from 'react';

import { useTranslation } from 'react-i18next';

import { Box, Typography, styled } from '@mui/material';

import type { CommentTemplateWithAction } from 'models/CommentTemplate';

import { formatDate } from 'utils/dateFormatter';

const StyledContainer = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
}));

const StyledRecord = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '6px',
}));

const StyledRow = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: '12px',
}));

interface CommentTemplateDetailsProps {
    commentTemplate: CommentTemplateWithAction;
}

const CommentTemplateDetails: React.FC<CommentTemplateDetailsProps> = ({
    commentTemplate,
}) => {
    const { t } = useTranslation('commentTemplates', {
        keyPrefix: 'DETAILS_MODAL',
    });

    return (
        <StyledContainer>
            <StyledRow>
                <StyledRecord>
                    <Typography variant="caption">
                        {t('CREATED_AT')}:
                    </Typography>
                    <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                        {formatDate(commentTemplate.created_at)}
                    </Typography>
                </StyledRecord>
                <StyledRecord>
                    <Typography variant="caption">
                        {t('UPDATED_AT')}:
                    </Typography>
                    <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                        {formatDate(commentTemplate.updated_at)}
                    </Typography>
                </StyledRecord>
            </StyledRow>
            <Typography variant="body2">{commentTemplate.note}</Typography>
        </StyledContainer>
    );
};

export default CommentTemplateDetails;
